module.exports = __webpack_public_path__ + "media/images/share-8f7deca4e2be5ff91343b67d13caeed8.png";